import { request } from 'src/services/request';
import {
  CategoryDTO,
  ResponseCodeSF,
} from 'src/features/common/types/salesforce/dto/application/category-dto';
import { LoggingService } from './logging-service';
import { getLoggingTraceId, getResponseAsObject } from 'src/helpers/logging';
import { getJourneyNameFromSessionStorage } from 'src/utils/SessionStorage/GetJourneyNameFromSessionStorage';
import { getBrowserName, getOSName } from 'src/helpers/browser';
import { Environment } from 'src/Environment';

interface AppUpdates {
  order_ref_number: string;
  journey_name: 'pos' | 'legacy';
  responses: ResponseCodeSF[];
}

const loggingService = new LoggingService();

const getUpdateInformation = (
  appUpdates: AppUpdates,
  abortController: AbortController,
  loggingBody?: Record<string, any>,
): Promise<CategoryDTO[]> => {
  const ENDPOINT = 'pending-app/codes';

  const startTime = performance.now();
  return request(ENDPOINT, {
    fetchOptions: {
      method: 'POST',
      body: JSON.stringify(appUpdates),
      signal: abortController.signal,
    },
  }).then((response) => {
    loggingService.info({
      traceId: getLoggingTraceId(),
      solutionType: undefined,
      journey: getJourneyNameFromSessionStorage(),
      currentStep: {
        subStepName: 'Login',
      },
      referenceNumber: undefined,
      timestamp: new Date().toISOString(),
      api: {
        responseTime: (performance.now() - startTime).toFixed(),
        statusCode: response.status,
        endpoint: response.url,
        responseBody: getResponseAsObject(response),
      },
      device: {
        platform: getOSName(navigator.userAgent),
        browserName: getBrowserName(navigator.userAgent),
      },
      url: window.location.href,
      environment: Environment.current.env,
      ...loggingBody,
    });
    if (response.status !== 200 || !response.result.updateInfo?.categories) {
      return [];
    }

    return response.result.updateInfo.categories;
  });
};

export const PendingAppService = { getUpdateInformation };
